import "antd/dist/antd.css";
import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Card } from "antd";
import { initialState, reducer } from "./reducer";
import { useSelector } from "react-redux";
import SimpleHeader from "../../../helpers/cards-helper/SimpleHeader";
import { ErrorCard } from "../Patronage/PatronageReferred/voters-list/components/List";
import Search from "./components/Search";
import PatronagerService from "../../../services/Election/Patronage/PatronagerService";
import VotersList from "./components/List";



const getErrorMessage = (err) => {
    let errorMessage = "Një gabim ndodhi gjatë komunikimit me serverin!";

    if (err?.response?.data?.Error) {
        errorMessage = err?.response?.data?.Error;
    }

    return errorMessage;
};


const setRowNumber = (items) => {
    let index = 0;
    return items?.map((item) => {
        index += 1;
        return {
            ...item,
            row_number: index
        };
    });
};


const updateItems = (dispatch, items, count) => {
    const action = {
        type: "set_items",
        payload: {
            items: setRowNumber(items),
            count: count,
        }
    };
    dispatch(action);
};



const PatronagerModule = () => {
    const token = useSelector((state) => state.Member.token);
    const [state, dispatch] = useReducer(reducer, initialState);
    const [errorMessage, setErrorMessage] = useState(null);


    useEffect(() => {
        updateLoading(true);
        PatronagerService.getVotingDayList(token)
        .then((response) => {
            const apiResponse = response.data;
            updateItems(dispatch, apiResponse, apiResponse?.length);
            setErrorMessage(null);
            updateLoading(false);
        })
        .catch((error) => {
            const errorMessage = getErrorMessage(error);
            setErrorMessage(errorMessage);
            updateItems(dispatch, [], 0);
            updateLoading(false);
        })
    }, [token, state.filters.refreshIndex]);


    const updateLoading = (isLoading) => {
        const action = {
            type: "set_loading",
            payload: isLoading,
        };
        dispatch(action);
    };


    const refreshList = () => {
        const action = {
            type: "refresh_list",
        };
        dispatch(action);
    };


    const onSuccess = () => {
        refreshList();
    };


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>

                {state.indexVisibility === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <SimpleHeader
                                title={"Dita e Votimit"}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col xl={15} lg={15} md={24} sm={24} xs={24}>
                            <Search
                                dispatch={dispatch}
                                initialFilters={state.filters.searchFilters}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-4">
                        <Col span={24}>

                            {state.isLoading === true && (
                                <Row gutter={24}>
                                    <Col xl={15} lg={15} md={24} sm={24} xs={24}>
                                        <Card loading={state.isLoading} />
                                    </Col>
                                </Row>
                            )}

                            {state.isLoading === false && (
                                <Row gutter={24}>
                                    <Col xl={15} lg={15} md={24} sm={24} xs={24}>

                                        {errorMessage !== null && (
                                            <Row gutter={24}>
                                                <Col span={24}>
                                                    <Card>
                                                        <ErrorCard
                                                            message={errorMessage}
                                                        />
                                                    </Card>
                                                </Col>
                                            </Row>
                                        )}

                                        {errorMessage === null && (
                                            <Row gutter={24}>
                                                <Col span={24}>
                                                    <VotersList
                                                        dispatch={dispatch}
                                                        items={state.items}
                                                        initialFilters={state.filters.searchFilters}
                                                        onSuccess={onSuccess}
                                                    />
                                                </Col>
                                            </Row>
                                        )}

                                    </Col>
                                </Row>
                            )}

                        </Col>
                    </Row>
                )}

            </Col>
        </Row>
    );
};


export default PatronagerModule;